import React from 'react'

import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import { useLocation, useNavigate } from 'react-router-dom'
import { CasoGeneralComponent } from 'defcol-caso-general'
import FormPrincipal from './components/form-principal'


const AprobacionPagoCiaTercero = () => {
    const { state } = useLocation()
    const idCasoLocation = state?.row?.IdCaso ? state.row.IdCaso : 33;
    const idImplicado = state?.row?.IdImplicado ? state.row.IdImplicado : 1;
    const idOrganizacionCaso = state?.row?.idOrganizacionCaso ? state.row.idOrganizacionCaso : 8600399880;
    const idTareaWFL = state?.row?.IdTarea ? state.row.IdTarea : 66;

    return (
        <Container>
            <Container>
                <Card className='mt-2'>
                    <Card.Header as='h6' className="text-center" style={{ backgroundColor: "#4F517A", color: "white" }} >
                        Aprobación u Objeción de Pago CIA's - Caso {idCasoLocation}
                    </Card.Header>
                    <Card.Body>
                        <CasoGeneralComponent idCaso={idCasoLocation} idImplicado={idImplicado} idOrganizacionCaso={idOrganizacionCaso} />
                    </Card.Body>
                </Card>

                <FormPrincipal idCaso={idCasoLocation} idOrgCaso={idOrganizacionCaso} idImplicado={idImplicado} idTareaWFL={idTareaWFL}/>
            </Container>
        </Container>
    )
}
export default AprobacionPagoCiaTercero;